export default "__VITE_ASSET__bcb4ad7a__"